<template>
    <div class="vrm-modal vrm-modal--remote-console-choice">
        <div class="vrm-modal__header-gradient"></div>
        <div class="vrm-modal__content">
            <vrm-remote-console-choice-container :id-site="idSite" :on-selected="onSelected" />
        </div>
        <modal-close-handle />
    </div>
</template>
<style scoped></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import VrmRemoteConsoleChoiceContainer from '@/vue/components/shared/VrmRemoteConsoleChoiceContainer.vue';

@Component({
    components: { VrmRemoteConsoleChoiceContainer, ModalCloseHandle },
})
@AngularDirective('vrm-remote-console-choice-modal')
@AngularLocaleBundle('modal')
export default class VrmRemoteConsoleChoiceModal extends Vue {
    @Prop({ type: Number })
    idSite;

    @Prop({ type: Function })
    onSelected;
}
</script>
